import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
export function BeforeAfter() {
  const [position, setPosition] = useState(50);
  const containerRef = useRef<HTMLDivElement>(null);
  const handleDrag = (e: React.MouseEvent | React.TouchEvent | MouseEvent | TouchEvent) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    let clientX = 0;
    if ('touches' in e) {
      clientX = e.touches[0].clientX;
    } else {
      clientX = (e as React.MouseEvent).clientX;
    }
    const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
    const percent = x / rect.width * 100;
    setPosition(percent);
  };
  return <section className="py-32 bg-obsidian relative" data-id="element-86">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-88">
          <h2 className="text-headline font-serif text-platinum mb-4" data-id="element-89">
            The Transformation
          </h2>
          <p className="text-silver max-w-2xl mx-auto" data-id="element-90">
            Drag to reveal the difference between a standard room and a QUBIX
            designed experience.
          </p>
        </motion.div>

        <div ref={containerRef} className="relative w-full aspect-[4/3] md:aspect-[21/9] rounded-2xl overflow-hidden border border-graphite cursor-ew-resize select-none" onMouseMove={e => e.buttons === 1 && handleDrag(e)} onTouchMove={handleDrag} data-id="element-91">
          {/* AFTER (Bottom Layer - QUBIX Design) */}
          <div className="absolute inset-0 bg-void flex items-center justify-end p-8 md:p-16" data-id="element-92">
            <div className="absolute inset-0 opacity-40" style={{
            background: 'radial-gradient(circle at 70% 30%, rgba(99,102,241,0.3), transparent 40%), radial-gradient(circle at 30% 70%, rgba(236,72,153,0.2), transparent 40%)'
          }} data-id="element-93"></div>
            <div className="relative z-10 w-1/2 text-right pl-12" data-id="element-94">
              <h3 className="text-title font-serif text-gradient-vibrant mb-4" data-id="element-95">
                Designed by QUBIX
              </h3>
              <ul className="space-y-3 text-platinum text-sm md:text-base inline-block text-left" data-id="element-96">
                <li data-id="element-97">
                  <span className="text-music mr-2" data-id="element-98">●</span> Invisible
                  architectural speakers
                </li>
                <li data-id="element-99">
                  <span className="text-social mr-2" data-id="element-100">●</span> Warm,
                  circadian-synced lighting
                </li>
                <li data-id="element-101">
                  <span className="text-relax mr-2" data-id="element-102">●</span> Motorized blackout
                  shades
                </li>
                <li data-id="element-103">
                  <span className="text-cinema mr-2" data-id="element-104">●</span> One-touch "Cinema"
                  scene
                </li>
              </ul>
            </div>
          </div>

          {/* BEFORE (Top Layer - Standard Design) */}
          <div className="absolute inset-0 bg-carbon flex items-center justify-start p-8 md:p-16 border-r border-gold" style={{
          clipPath: `polygon(0 0, ${position}% 0, ${position}% 100%, 0 100%)`
        }} data-id="element-105">
            <div className="relative z-10 w-[40vw] pr-12" data-id="element-106">
              <h3 className="text-title font-serif text-silver mb-4" data-id="element-107">
                Standard Room
              </h3>
              <ul className="space-y-3 text-ash text-sm md:text-base" data-id="element-108">
                <li data-id="element-109">• Visible, bulky speakers</li>
                <li data-id="element-110">• Harsh, static overhead lights</li>
                <li data-id="element-111">• Manual window treatments</li>
                <li data-id="element-112">• Multiple remotes & switches</li>
              </ul>
            </div>
          </div>

          {/* Slider Handle */}
          <div className="absolute top-0 bottom-0 w-0.5 bg-gold shadow-[0_0_10px_#C9A96E] pointer-events-none z-20" style={{
          left: `${position}%`
        }} data-id="element-113">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-void border-2 border-gold flex items-center justify-center shadow-lg" data-id="element-114">
              <div className="flex space-x-1" data-id="element-115">
                <div className="w-0.5 h-3 bg-gold rounded-full" data-id="element-116"></div>
                <div className="w-0.5 h-3 bg-gold rounded-full" data-id="element-117"></div>
              </div>
            </div>
          </div>

          <input type="range" min="0" max="100" value={position} onChange={e => setPosition(Number(e.target.value))} className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize z-30" aria-label="Compare before and after transformation" data-id="element-118" />
        </div>
      </div>
    </section>;
}